import BackgroundEffect from '../components/BackgroundEffect';
const TermsAndConditions = () => {
    const styles = {
        container: {
            maxWidth: "950px",
            margin: "50px auto",
            padding: "50px",
            background: "linear-gradient(180deg, #ffffff 0%, #f5f8fa 100%)",
            borderRadius: "16px",
            boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
            fontFamily: "'Segoe UI', Roboto, sans-serif",
            color: "#003e64",
            lineHeight: "1.8",
            transition: "all 0.3s ease-in-out",
        },
        title: {
            fontSize: "2.6rem",
            fontWeight: "700",
            marginBottom: "10px",
            textAlign: "center",
            color: "#003e64",
            letterSpacing: "0.5px",
        },
        subtitle: {
            textAlign: "center",
            marginBottom: "35px",
            color: "#374651",
            fontSize: "1rem",
            backgroundColor: "#fdf3eb",
            padding: "15px",
            borderRadius: "10px",
            border: "1px solid #e87115",
        },
        section: {
            marginBottom: "35px",
            paddingBottom: "25px",
            borderBottom: "1px solid #e1e5e9",
        },
        sectionTitle: {
            fontSize: "1.3rem",
            fontWeight: "700",
            marginBottom: "12px",
            color: "#e87115",
            textTransform: "uppercase",
            letterSpacing: "0.6px",
        },
        list: {
            marginLeft: "25px",
            paddingLeft: "10px",
            listStyleType: "disc",
        },
        listItem: {
            marginBottom: "6px",
            fontSize: "1.2rem",
        },
        paragraph: {
            fontSize: "1.2rem",
            color: "#003e64",
            marginBottom: "12px",
        },
        footer: {
            borderTop: "2px solid #e87115",
            marginTop: "40px",
            paddingTop: "25px",
            fontSize: "0.95rem",
            textAlign: "center",
            color: "#003e64",
            fontWeight: "600",
            letterSpacing: "0.4px",
        },
        contact: {
            marginTop: "15px",
            lineHeight: "1.6",
        },
        link: {
            color: "#e87115",
            textDecoration: "none",
            fontWeight: "600",
        },
        linkHover: {
            textDecoration: "underline",
        },
    };

    return (
        <div style={styles.container}>
            <BackgroundEffect />
            <h1 style={styles.title}>Terms & Conditions</h1>
            <p style={styles.subtitle}>
                <strong>Effective Date:</strong> 2nd September 2025 <br />
                <strong>Company:</strong> JSKM Technologies Private Limited <br />
                <strong>Website:</strong>{" "}
                <a
                    href="https://www.jskmtechnologies.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={styles.link}
                >
                    https://www.jskmtechnologies.com
                </a>
                <br />
                <strong>Email:</strong>{" "}
                <a href="mailto:contact@jskmtechnologies.com" style={styles.link}>
                    contact@jskmtechnologies.com
                </a>
                <br />
                <strong>Phone:</strong> +91 96763 62000
            </p>

            {/* Section 1 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>1. Introduction</h2>
                <p style={styles.paragraph}>
                    Welcome to <b>JSKM Technologies Private Limited</b> (“Company,” “we,” “our,” or “us”).<br />
                    These Terms & Conditions (“Terms”) govern your access to and use of our website, applications, software, and services, including but not limited to TrustMee, IT solutions, HR consulting, medical billing, and export/import services.<br />
                    By accessing or using our services, you agree to comply with these Terms in full.<br />
                    If you do not agree with any part of these Terms, please do not use our website or services.
                </p>
            </div>

            {/* Section 2 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>2. Services Offered</h2>
                <p style={styles.paragraph}>JSKM Technologies Private Limited provides professional and technology-driven services, including but not limited to:</p>
                <ul style={styles.list}>
                    <li style={styles.listItem}>
                        <strong>IT Services:</strong> Website Development, App Development, AI Solutions, Software Development, and Cloud Services.
                    </li>
                    <li style={styles.listItem}>
                        <strong>TrustMee Platform:</strong> Product Authentication & Warranty Verification Platform.
                    </li>
                    <li style={styles.listItem}>
                        <strong>HR Consulting:</strong> Recruitment, Staffing, and Workforce Management.
                    </li>
                    <li style={styles.listItem}>
                        <strong>Medical Coding & Billing:</strong> Healthcare data processing and billing support.
                    </li>
                    <li style={styles.listItem}>
                        <strong>Export & Import Services:</strong> Trade facilitation and logistics services.
                    </li>
                </ul>
                <p style={styles.paragraph}>Each service may be subject to separate agreements, quotations, or project documentation specifying deliverables, timelines, and costs.</p>
            </div>

            {/* Section 3 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>3. Acceptance of Terms</h2>
                <p style={styles.paragraph}>By using our services or visiting our website, you confirm that you:</p>
                <ul style={styles.list}>
                    <li style={styles.listItem}>Have read and understood these Terms;</li>
                    <li style={styles.listItem}>Are at least 18 years old or have legal capacity to contract;</li>
                    <li style={styles.listItem}>Agree to comply with all applicable laws and regulations.</li>
                </ul>
            </div>

            {/* Section 4 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>4. Payments and Billing</h2>
                <ul style={styles.list}>
                    <li style={styles.listItem}>All payments must be made directly to <b>JSKM Technologies Private Limited</b> as specified in the invoice.</li>
                    <li style={styles.listItem}>Invoices are issued after completion of deliverables or as per mutually agreed milestones.</li>
                    <li style={styles.listItem}><b>Refunds are not applicable</b> once payment is made, as services are custom-delivered before billing.</li>
                    <li style={styles.listItem}>Any delay in payment may result in suspension or termination of services.</li>
                    <li style={styles.listItem}>JSKM Technologies reserves the right to charge interest or late fees on overdue payments.</li>
                </ul>
            </div>

            {/* Section 5 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>5. Intellectual Property Rights</h2>
                <p style={styles.paragraph}>
                    All content, code, software, designs, and materials developed or provided by JSKM Technologies remain the intellectual property of the Company unless explicitly transferred through a written agreement.<br />
                    Clients are granted a limited, non-transferable license to use deliverables solely for their intended business purpose.<br />
                    Unauthorized reproduction, resale, or redistribution of our materials is strictly prohibited.
                </p>
            </div>

            {/* Section 6 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>6. Confidentiality</h2>
                <p style={styles.paragraph}>
                    Both the Company and the Client agree to maintain the confidentiality of all non-public, proprietary, or sensitive business information shared during project execution.<br />
                    Confidential information shall not be disclosed to third parties without written consent, except where required by law.
                </p>
            </div>

            {/* Section 7 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>7. Limitation of Liability</h2>
                <p style={styles.paragraph}>
                    To the fullest extent permitted by law:
                </p>
                <ul style={styles.list}>
                    <li style={styles.listItem}>JSKM Technologies shall not be liable for indirect, incidental, consequential, or special damages (including loss of data, profit, or goodwill).</li>
                    <li style={styles.listItem}>The Company’s total liability, under any circumstances, shall not exceed the total amount invoiced for the specific service in question.</li>
                </ul>
            </div>

            {/* Section 8 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>8. Third-Party Services</h2>
                <p style={styles.paragraph}>
                    Some services may integrate or rely on third-party systems (e.g., payment gateways, hosting providers, APIs).<br />
                    JSKM Technologies is not responsible for downtime, data loss, or any malfunction caused by third-party services.
                </p>
            </div>

            {/* Section 9 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>9. Refund & Cancellation Policy</h2>
                <p style={styles.paragraph}>
                    All services are project-based and delivered before invoicing.<br />
                    Therefore, <b>no refunds, chargebacks, or cancellations</b> are accepted after payment confirmation.<br />
                    Clients are encouraged to review deliverables before making payments.
                </p>
            </div>

            {/* Section 10 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>10. User Responsibilities</h2>
                <p style={styles.paragraph}>
                    Users and clients must:
                </p>
                <ul style={styles.list}>
                    <li style={styles.listItem}>Provide accurate and up-to-date information.</li>
                    <li style={styles.listItem}>Refrain from illegal or abusive use of our systems.</li>
                    <li style={styles.listItem}>Respect copyright and proprietary rights of all materials provided.</li>
                    <li style={styles.listItem}>Use the website and services in compliance with local and international laws.</li>
                </ul>
            </div>

            {/* Section 11 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>11. Termination of Services</h2>
                <p style={styles.paragraph}>
                    JSKM Technologies may suspend or terminate any service if:
                </p>
                <ul style={styles.list}>
                    <li style={styles.listItem}>The client fails to make timely payments.</li>
                    <li style={styles.listItem}>The client breaches these Terms or engages in misuse.</li>
                    <li style={styles.listItem}>Unforeseen technical, operational, or legal issues require discontinuation.</li>
                </ul>
                <p style={styles.paragraph}>
                    Upon termination, all unpaid dues become immediately payable.
                </p>
            </div>

            {/* Section 12 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>12. Disclaimer of Warranties</h2>
                <p style={styles.paragraph}>
                    All services and materials are provided on an <b>“as-is”</b> and <b>“as-available”</b> basis.<br />
                    While we strive for accuracy and reliability, JSKM Technologies makes no warranties of any kind, express or implied, regarding:
                </p>
                <ul style={styles.list}>
                    <li style={styles.listItem}>Continuous or error-free operation of services,</li>
                    <li style={styles.listItem}>Fitness of deliverables for a particular purpose, or</li>
                    <li style={styles.listItem}>Non-infringement of third-party rights.</li>
                </ul>
            </div>

            {/* Section 13 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>13. Indemnification</h2>
                <p style={styles.paragraph}>
                    You agree to indemnify and hold harmless JSKM Technologies, its directors, employees, and affiliates from any claims, damages, or losses resulting from your:
                </p>
                <ul style={styles.list}>
                    <li style={styles.listItem}>Violation of these Terms,</li>
                    <li style={styles.listItem}>Misuse of services, or</li>
                    <li style={styles.listItem}>Infringement of third-party rights.</li>
                </ul>
            </div>

            {/* Section 14 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>14. Governing Law and Jurisdiction</h2>
                <p style={styles.paragraph}>
                    These Terms shall be governed by and construed in accordance with the laws of <b>India.</b>
                    All disputes arising under these Terms shall be subject to the exclusive jurisdiction of the <b>courts of Hyderabad, Telangana.</b>
                </p>
            </div>

            {/* Section 15 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>15. Modifications to Terms</h2>
                <p style={styles.paragraph}>
                    JSKM Technologies reserves the right to modify or update these Terms & Conditions at any time.<br/>
                    Revised Terms will be posted on our official website with an updated <b>Effective Date.</b><br/>
                    Continued use of our services after such updates constitutes acceptance of the new Terms.
                </p>
            </div>

            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>16. Contact Information</h2>
                <p style={styles.paragraph}>For any questions or concerns regarding these Terms & Conditions, please contact:</p>
                <p style={styles.contact}>
                    <b>JSKM Technologies Private Limited</b> <br />
                    📧 <b>Email:</b>{" "}
                    <a href="mailto:contact@jskmtechnologies.com" style={styles.link}>
                        contact@jskmtechnologies.com
                    </a>{" "}
                    <br />
                    📞 <b>Phone:</b> +91 96763 62000 <br />
                    🌐 <b>Website:</b>{" "}
                    <a
                        href="https://www.jskmtechnologies.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={styles.link}
                    >
                        https://www.jskmtechnologies.com
                    </a>
                </p>
            </div>
        </div>
    );
};

export default TermsAndConditions;